import VoiceService, { VcBackendUri, TtsBackendUri } from "./VoiceService";


export const VcGetVoices = () => VoiceService.get(VcBackendUri + '/voices')
export const TtsGetVoices = () => VoiceService.get(TtsBackendUri + '/voices')

// export const GetVoices = async (): Promise<any> => {
//     let items = [
//             {
//                 "voice_id": "xiaoling",
//                 "nickname": "晓凌",
//                 "voice_type": "标准女声",
//                 "gender": "Female",
//                 "avatar_url": "/static/img/intellectual_female.png",
//                 "default_text": "我一定要做一件轰轰烈烈的事，这样才不负我的青春。"
//             },
//             {
//                 "voice_id": "liugenghong",
//                 "nickname": "刘畊宏",
//                 "voice_type": "运动男声",
//                 "gender": "Male",
//                 "avatar_url": "/static/img/young_male.png",
//                 "default_text": "在全市形成了上下联动、共同推进的良好氛围。"
//             }
//         ]
//     // items = items.concat(items);  // 8
//     // items = items.concat(items);  // 12
//     return {data: items};
// }

export interface VcGenerateParam {
    voice: string,
    encoding: string,
    rate: number,
    source_encoding: string
}

export interface TtsGenerateParam {
    text: string,
    voice: string,
    volume: number,
    speech_rate: number
    source: number
}

export interface GenerateMusicParam {
    task: string,
    text? : string[],
    melody?: string,
    audio?: string,
    sample_rate? : number,
    seed?: number,
    duration: number,
}

// const GetHardware = () => VoiceService.get('/hardware')
export const GetHardware = async (): Promise<any> => {
    // https://confluence.mthreads.com/pages/viewpage.action?pageId=132390451
    return {device: 'S5000'};
}

type audiosItem = {
    audio_bytes: string;
    text: string;
};

export interface AudioCopyParam {
    audios: audiosItem[],
}
